<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  //  data() {

  //  }
}
</script>
 
<style lang="less">
@import "./common.less";
#app{
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue